import { gql } from "@/__generated__/gql";

export const CREATE_ACTION_GOAL = gql(`
  mutation CreateActionGoal(
    $orgId: ID!
    $userId: ID!
    $date: Date!
    $capacity: RiseUserActionCapacityEnum!
  ) {
    createRiseUserActionGoalMutation(input: {
      capacity: $capacity
      organizationId: $orgId
      date: $date
      userId: $userId
    }) {
      clientMutationId
      errors {
        title
        message
      }
      riseUserActionGoal {
        id
        goal
      }
    }
  }
  `);
